import { useList } from '@refinedev/core';
import { useMemo } from 'react';

import { AvailableResources } from '@/config';

import type { PlanningCropOption, PlanningCropsResponse } from './types';

const useGetCrops = () => {
  const { data, isLoading, fetchStatus, error, refetch } =
    useList<PlanningCropsResponse>({
      resource: AvailableResources.CROPS,
      pagination: {
        current: 1,
        pageSize: 1000
      }
    });

  const options: PlanningCropOption[] = useMemo(() => {
    if (!data?.data) {
      return [];
    }

    return (data?.data as unknown as PlanningCropsResponse).items.map(item => ({
      label: item.name,
      value: item.id,
      isHybrid: item.is_hybrid
    }));
  }, [data]);

  return {
    options,
    isLoading: isLoading || fetchStatus === 'fetching',
    error,
    refetch
  };
};

export default useGetCrops;
